var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1462",
    clipPath: "url(#clip0_16854_96626)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 576",
    width: 62,
    height: 43,
    rx: 8,
    fill: "url(#paint0_linear_16854_96626)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 578",
    filter: "url(#filter0_d_16854_96626)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 6,
    width: 47,
    height: 44,
    rx: 8,
    fill: "url(#paint1_linear_16854_96626)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 577",
    filter: "url(#filter1_d_16854_96626)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 13,
    width: 30,
    height: 49,
    rx: 8,
    fill: "url(#paint2_linear_16854_96626)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16854_96626",
    x: -9,
    y: -12,
    width: 95,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16854_96626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16854_96626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_16854_96626",
    x: 8,
    y: -5,
    width: 78,
    height: 97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16854_96626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16854_96626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16854_96626",
    x1: 4.89473,
    y1: 0.00000194586,
    x2: 45.3139,
    y2: 49.6721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0236636,
    stopColor: "#FCA6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893471,
    stopColor: "#F95370"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16854_96626",
    x1: 18.7105,
    y1: 6,
    x2: 60.7662,
    y2: 44.2888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0236636,
    stopColor: "#FCA6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893471,
    stopColor: "#FFA87D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16854_96626",
    x1: 34.3684,
    y1: 13,
    x2: 72.9556,
    y2: 33.1359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0236636,
    stopColor: "#FCA6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893471,
    stopColor: "#FFA87D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16854_96626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLarge);
export default __webpack_public_path__ + "static/media/mobileLarge.9d45d62af109eca5607c7cea49a95031.svg";
export { ForwardRef as ReactComponent };